import { Injectable } from '@angular/core';
import {ParentService} from '../A2-utils/ParentClass/ParentService';
import {Router} from '@angular/router';
import {Headers, Http, RequestMethod, RequestOptions, Response} from '@angular/http';
import {constant} from '../../app.constants';
import {Observable} from 'rxjs/Observable';
import {BehaviorSubject} from 'rxjs/BehaviorSubject';
import { IUser } from 'app/core/interfaces/user.interface';

@Injectable()
export class UsersService extends ParentService {
  smartTableData = [];

  private currentUserInformationSubject: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  currentUserInformation$: Observable<any> = this.currentUserInformationSubject.asObservable();

  private infoManagers: BehaviorSubject<IUser[]> = new BehaviorSubject<IUser[]>([]);
  infoManagers$: Observable<IUser[]> = this.infoManagers.asObservable();

  constructor(private _http: Http, private route: Router) {
    super();
    // this.verifyToken(this._http, this.route);
  }

  /**
   * @description Sends the current user information to the subject.
   * @param userInformation The information of the current user.
   */
  public sendCurrentUserInformation(userInformation: any): void {
    this.currentUserInformationSubject.next(userInformation);
  }

  public sendInfoManagers(managerInformation: IUser[]): void {
    this.infoManagers.next(managerInformation);
  }

  /**
   * @@description:
   * @param profileId
   * @returns {Observable<any>}
   */
  public getMenuByProfileId(profileId) {
    return this._http.get(constant.URL_LIST_MENU + profileId, this.getHeader())
      .map(resp => resp.json());
  }

  /**
   * @name getMenuAll
   * @desc Cargar listado de modulos y submodulos
   * @return http
   */
  public getMenuAll() {
    return this._http.get(constant.URL_LIST_MENU + 1 + '?showAll=true', this.getHeader())
      .map(resp => resp.json());
  }

  /**
   *@description:
   * @returns {Observable<any>}
   */
  public getUserProfile() {
    return this._http.get(constant.URL_USER_PROFILE, this.getHeader())
      .map(resp => resp.json())
      .catch((error: any) => this.validate401Error(error, this.route));
  }

  /**
   * @description:
   * @param {string} filter
   * @param {boolean} active
   * @returns {Observable<any>}
   */
  public getUsersList(filter: string, active: boolean) {
    return this._http
      .get(constant.URL_USER_PROFILE_GET_FILTER + '?filter=' + filter + '&showInactive=' + active, this.getHeader())
      .map(res => res.json())
      .catch((error: any) => this.validate401Error(error, this.route));
  }

  /**
   * @description:
   * @param {number} param
   * @returns {Observable<any>}
   */
  public getUser(param: number) {
    return this._http.get(constant.URL_USER_PROFILE_BY_ID + param, this.getHeader())
      .map(
        res => res.json()
      );
  }

  /**
   * @description:
   * @returns {Observable<any>}
   */
  public getRoles() {
    return this._http.get(constant.URL_ROLE, this.getHeader()).
    map(res => res.json());
  }

  public getRolesByUserType(id) {
    return this._http.get(constant.URL_ROLE + `/searchByRoleType/${id}`, this.getHeader()).
    map(res => res.json());
  }


  /**
   * @description
   * @param id
   * @returns {Observable<any>}
   */
  public getSessions(id) {
    return this._http.get(constant.URL_USER_ACTIVE_SESSIONS + id + '?showActive=true',
      this.getHeader()).map(res => res.json());
  }

  /**
   * @description:
   * @param {number} param
   * @param {string} searchUser
   * @returns {Promise<any>}
   */
  public getData(param: number, searchUser: string): Promise < any > {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        resolve(this.smartTableData);
      }, 1000);
    });
  }

  /**
   * @description:
   * @param data
   * @returns {Observable<any>}
   */
  public postData(data: any) {
    const bodyString = JSON.stringify(data);
    const headers = new Headers({
      'Content-Type': 'application/json',
      'Version': this.localVersion
    });
    const options = new RequestOptions({
      headers: headers
    });

    return this._http.post(constant.URL_USER_PROFILE, bodyString, this.headerPost())
      .map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json()));
  }

  /**
   * @description
   * @param data
   * @returns {Observable<any>}
   */
  public registerUser(data) {
    const bodyString = JSON.stringify(data);

    return this._http.post(constant.URL_USER_PROFILE_POST, bodyString, this.headerPost())
      .map((res: Response) => res.json(), (error: Response) => error.json())
      .catch((error: any) => Observable.throw(error.json()));
  }


  /**
   * @description:
   * @param data
   * @returns {Observable<any>}
   */
  public putData(data: any) {
    const bodyString = JSON.stringify(data);
    const headers = new Headers({
      'Content-Type': 'application/json',
      'Version': this.localVersion
    });
    const options = new RequestOptions({
      headers: headers
    });

    // return this._http.put(constants.URL_USER_PROFILE, bodyString, options)
    return this._http.put(constant.URL_USER_PROFILE, bodyString, this.headerPost())
      .map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json()));
  }

  /**
   * @description:
   * @param data
   * @returns {Observable<any>}
   */
  public deleteData(data: any) {
    const headers = new Headers({
      'Content-Type': 'application/json',
      'Version': this.localVersion
    });
    const options = new RequestOptions({
      headers: headers
    });

    return this._http.delete(`${constant.URL_USER_PROFILE}/${data}`, this.getHeader())
      .map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json().error || 'Server error'));
  }

  /**
   * @description:
   * @returns {Observable<any>}
   */
  getPayorList() {
    return this._http.get(constant.URL_PAYOR_LIST, this.getHeader())
      .map(resp => resp.json());
  }

  /**
   * @description:
   * @param token
   * @param userprofile
   */
  public deleteSession(token, userprofile) {
    const body = {
      token: token,
      userprofile: userprofile
    };

    const options = new RequestOptions({
      body: body,
      method: RequestMethod.Delete
    });

    this._http
      .delete(constant.URL_SESSION, options)
      .map((resp: Response) => resp.json());
  }

  /**
   * @description:
   * @param {any[]} data
   * @returns {Observable<any>}
   */
  public closeAllSessions(data: any[]) {
    const bodyString = JSON.stringify(data);
    return this._http.put(constant.URL_CLOSE_ALL_SESSIONS, bodyString, this.headerPost())
      .map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json().message || error.json().error || 'Server error'));
  }

  /**
   * DEcription:
   * @returns {Observable<any>}
   */
  public getAllProviders() {
    return this._http.get(constant.URL_ENABLE_COMPANIES, this.getHeader())
      .map(resp => resp.json());
  }

  public getAllProvidersByRider(riderId: number): Observable<any> {
    return this._http.get(`${constant.URL_ENABLE_COMPANIES}&RiderId=${riderId}&orderBy=true`, this.getHeader())
      .map(resp => resp.json())
      .catch(error => Observable.throw(error.json()));
  }

  /**
   * DEcription:
   * @returns {Observable<any>}
   */
  public getAllPCPs() {
    return this._http.get(constant.URL_PCP, this.getHeader())
      .map(resp => resp.json());
  }

  /**
   * @description:
   * @returns {Observable<any>}
   */
  public getProvidersForUser(sort = ' ') {
    return this._http.get(constant.USER_PROVIDERS + sort, this.getHeader())
      .map(resp => resp.json());
  }

  /**
   * @description:
   * @returns {Observable<any>}
   */
  public getProvidersForUserOrderBy() {
    return this._http.get(constant.USER_PROVIDERS + '&orderBy=true', this.getHeader())
      .map(resp => resp.json());
  }

  /**
   * @description:
   * @returns {Observable<any>}
   */
  public getAllUserType() {
    return this._http.get(constant.USER_TYPE, this.getHeader())
      .map(resp => resp.json());
  }

  /**
   * @description Actualizar la imagen de perfil del usuario
   * @param {base64} image
   * @returns {Observable<any>}
   */
  public updateAvatar(image: string) {
    const bodyString = JSON.stringify({
      'UserPhoto': image
    });
    return this._http.put(constant.URL_UPDATE_AVATAR, bodyString, this.headerPost())
      .map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json() || 'Server error'));
  }

  public getEnableCompanies(sort?) {
    return this._http.get(constant.URL_ENABLE_PROVIDER + sort, this.getHeader())
      .map(resp => resp.json());
  }

  public userProfileHistory(id: number) {
    return this._http.get(`${constant.URL_USER_PROFILE}/${id}/History`, this.getHeader())
          .map(resp => resp.json());
  }


  GetManagedUsers(managerUserProfileId: number) {
    const url = `${constant.URL_ACTIVE_MANAGER_USERS}/${managerUserProfileId}`;
    return this._http
      .get(url, this.getHeader())
      .map((resp: Response) => resp.json())
      .catch((error) => Observable.throw(error.json()));
  }

  public removeManagedUsersRelation(
    selectedUserProfileIds: number[],
    managerId: number,
  ) {
    const body = {
      ManagerUserProfileId: managerId,
      UserProfileIds: selectedUserProfileIds
    };
    return this._http
      .post(
        constant.URL_REMOVE_MANAGED_USERS_RELATION,
        body,
        this.headerPost(),
      )
      .map((res: Response) => res.json())
      .catch((error) =>  Observable.throw(error.json()));
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/users/users.service.ts